import {
	ForumOutlined as ForumOutlinedIcon,
	Fullscreen as FullscreenIcon,
	Groups as GroupsIcon,
	Lock as LockIcon,
	Message as MessageIcon,
	MoodOutlined as MoodOutlinedIcon,
} from '@mui/icons-material'

import {
	GraphicsSummaryList,
	ProductsBubbleChart,
} from '../home/graphics'
import RestrictedChart from '../home/graphics/RestrictedChart'
import { ChartModal } from '../home/graphics/ChartModal'
import MetricTrend from '../ui/MetricTrend'

import {
	renderBubbleChart,
	renderSatisfactionChart,
	renderSummaryChart,
} from '../../services/utils'

const ConversationOverview = ({
	analytics,
	enterprise,
	totalMessages,
	accountOverviewGraphics,
	mobileChartOpen,
	onOpenMobileChart,
	onCloseMobileChart,
	gridStyle,
	panelStyle,
	bodyStyle,
	summaryListStyle,
}) => {
	return (
		<>
			<div className="scout-stats-grid scout-stats-grid--compact">
				<article className="scout-stat-card">
					<div className="scout-stat-card__header">
						<span>Grupos</span>
						<GroupsIcon />
					</div>
					<div className="scout-stat-card__value-row">
						<div className="scout-stat-card__value-group">
							<strong>{analytics?.groups || 0}</strong>
						</div>
						<MetricTrend trend={{
							value: Math.abs(analytics?.groupsChange ?? 0),
							direction: (analytics?.groupsChange ?? 0) >= 0 ? 'up' : 'down',
						}} />
					</div>
				</article>

				<article className="scout-stat-card">
					<div className="scout-stat-card__header">
						<span>Conversas</span>
						<ForumOutlinedIcon />
					</div>
					<div className="scout-stat-card__value-row">
						<div className="scout-stat-card__value-group">
							<strong>{analytics?.conversations || 0}</strong>
						</div>
						<MetricTrend trend={{
							value: Math.abs(analytics?.conversationsChange ?? 0),
							direction: (analytics?.conversationsChange ?? 0) >= 0 ? 'up' : 'down',
						}} />
					</div>
				</article>

				<article className="scout-stat-card">
					<div className="scout-stat-card__header">
						<span>Mensagens</span>
						<MessageIcon />
					</div>
					<div className="scout-stat-card__value-row">
						<div className="scout-stat-card__value-group">
							<strong>{totalMessages || 0}</strong>
						</div>
						<MetricTrend trend={{
							value: Math.abs(analytics?.totalMessagesChange ?? 0),
							direction: (analytics?.totalMessagesChange ?? 0) >= 0 ? 'up' : 'down',
						}} />
					</div>
				</article>

				{renderSatisfactionChart(enterprise)
					? <article className="scout-stat-card">
						<div className="scout-stat-card__header">
							<span>Índice de Satisfação</span>
							<MoodOutlinedIcon />
						</div>
						<div className="scout-stat-card__value-row">
							<div className="scout-stat-card__value-group">
								<strong>{typeof analytics?.sentiment === 'number' && analytics.sentiment >= 0 ? analytics.sentiment.toFixed(1) : '0.0'}</strong>
							</div>
							<MetricTrend trend={{
								value: Math.abs(analytics?.sentimentChange ?? 0),
								direction: (analytics?.sentimentChange ?? 0) >= 0 ? 'up' : 'down',
							}} />
						</div>
					</article>
					: <article className="scout-stat-card">
						<div className="scout-stat-card__header">
							<span>Índice de Satisfação</span>
							<LockIcon />
						</div>
					</article>
				}
			</div>

			<div className="scout-content-grid scout-content-grid--home scout-content-grid--conversation-empty" style={gridStyle}>
				<div className="scout-graphics-panel-wrapper">
					{renderSummaryChart(enterprise)
						? <GraphicsSummaryList
							items={accountOverviewGraphics.summaries}
							empty={!accountOverviewGraphics.summaries.length}
							panelStyle={panelStyle}
							bodyStyle={bodyStyle}
							listStyle={summaryListStyle}
						/>
						: <RestrictedChart title="Resumos" />
					}
					<button
						type="button"
						className="scout-graphics-expand-trigger"
						onClick={() => onOpenMobileChart('summaries')}
						aria-label="Expandir Resumos"
					>
						<FullscreenIcon fontSize="small" />
						<span>Ver gráfico</span>
					</button>
				</div>
				<div className="scout-graphics-panel-wrapper">
					{renderBubbleChart(enterprise)
						? <ProductsBubbleChart
							data={accountOverviewGraphics.products}
							empty={!accountOverviewGraphics.products.items.length}
							panelStyle={panelStyle}
							bodyStyle={bodyStyle}
						/>
						: <RestrictedChart title="Produtos e Serviços" />
					}
					<button
						type="button"
						className="scout-graphics-expand-trigger"
						onClick={() => onOpenMobileChart('products')}
						aria-label="Expandir Produtos e Serviços"
					>
						<FullscreenIcon fontSize="small" />
						<span>Ver gráfico</span>
					</button>
				</div>
			</div>

			{mobileChartOpen === 'summaries' && (
				<ChartModal title="Resumos" onClose={onCloseMobileChart}>
					{renderSummaryChart(enterprise)
						? <GraphicsSummaryList
							items={accountOverviewGraphics.summaries}
							empty={!accountOverviewGraphics.summaries.length}
						/>
						: <RestrictedChart title="Resumos" />
					}
				</ChartModal>
			)}
			{mobileChartOpen === 'products' && (
				<ChartModal title="Produtos e Serviços" onClose={onCloseMobileChart}>
					{renderBubbleChart(enterprise)
						? <ProductsBubbleChart
							data={accountOverviewGraphics.products}
							empty={!accountOverviewGraphics.products.items.length}
						/>
						: <RestrictedChart title="Produtos e Serviços" />
					}
				</ChartModal>
			)}
		</>
	)
}

export default ConversationOverview